import { generate_pdf_content as generatePDFContent } from './pdf_template'
import { componentStatusList } from './support_list'
import { checklistApi, hostAppApi, documentUrl } from '../plugins/axios_settings'
export default {
  async downloadReportHelper (item, token, logoBase64, isEmailReport = false, allTransData, baseApi) {
    const checklistId = item.checklist_api_id
    const formId = item.checklist_template_api_id
    const formName = item.title
    const checklilstName = item.checklist_name
    const projectdata = item.projectdata

    let listOfDocuments = {}

    const headers = { headers: { 'X-AccessToken': token } }

    // 1) documents
    const documentResponse = await checklistApi.get(`/documents/get_checklist_documents/${checklistId}`)

    if (documentResponse?.data?.length) {
      const result = documentResponse.data.map(el => ({
        ...el,
        imgObj: this.mimeTypeOfAttachment(el)
      }))

      listOfDocuments = result.reduce((acc, doc) => {
        const key = doc.property_name
        if (!acc[key]) acc[key] = []
        acc[key].push(doc)
        return acc
      }, {})
    }

    // 2) form properties
    const formPropsRes = await checklistApi.get(`formproperties/get_by_form/${formId}`, headers)
    let listOfFields = formPropsRes.data || []

    for (let i = 0; i < listOfFields.length; i++) {
      const field = listOfFields[i]

      field.default_value = field.default_value ? JSON.parse(field.default_value) : null

      if (field.type === 18) {
        const defaultValue = field.default_value
        if (defaultValue?.grid_data?.labels) {
          field.showSum = this.checkAndGetSumRowData(defaultValue.grid_data.labels)
        }
      }

      const panelId = field?.default_value?.panelId
      const getPanelFieldIndex = panelId ? listOfFields.findIndex(x => x._id === panelId) : -1

      if (getPanelFieldIndex >= 0) {
        field.isPanelField = true
        if (!listOfFields[getPanelFieldIndex].panel_fields) listOfFields[getPanelFieldIndex].panel_fields = []
        listOfFields[getPanelFieldIndex].panel_fields.push(Object.assign({ ...field }, { isPanelField: false }))
      }

      // attach docs to field
      const attachments = []
      for (const docs of Object.values(listOfDocuments)) {
        attachments.push(...docs.filter(doc => doc.property_id === field._id))
      }
      field.documents = attachments.length ? attachments : []
    }

    // 3) checklist data
    const checklistRes = await checklistApi.get(`checklists/${checklistId}`, headers)
    const raw = checklistRes.data
    const data = raw?.data ? JSON.parse(raw.data) : {}

    for (const key in data) {
      if (/_filter/.test(key)) {
        const orgKey = key.replace(/_filter$/, '')
        if (Object.keys(data[key] || {}).length > 0) data[orgKey] = data[key]
      }
    }

    const fields = data
    const model = { content: '' }

    // 4) grids with large columns
    const dataGridsWithLargeColumns =
      listOfFields.filter(x => x.type === 18 && x?.default_value?.grid_data?.labels?.length > 5)

    const ids = dataGridsWithLargeColumns.map(x => x._id) || []
    listOfFields = listOfFields.filter(x => !ids.includes(x._id))

    // 5) main pdf content
    const content = this.generatingContentForPDF(
      formName, listOfFields, fields, logoBase64, checklilstName, projectdata, allTransData, item.report_header
    )
    model.content = btoa(unescape(encodeURIComponent(content)))

    // 6) datagrid pdf content
    if (dataGridsWithLargeColumns.length) {
      const dataGridShow = true
      const dataGridContent = this.generatingContentForPDFDataGrid(
        formName,
        dataGridsWithLargeColumns,
        fields,
        logoBase64,
        '',
        [],
        allTransData,
        dataGridShow,
        item.report_header
      )

      model.datagrid_content = btoa(unescape(encodeURIComponent(dataGridContent)))

      const paper = dataGridsWithLargeColumns[0]?.default_value?.grid_data?.paper
      model.islandscapedatagrid = !!paper?.islandscapedatagrid
      model.datagridpdfpagesize = paper?.paperSize ?? 1
    }

    // 7) generate pdf
    const pdfRes = await hostAppApi.post(
      `${baseApi}checklists/generate_pdf/${formId}/${checklistId}`,
      model
    )

    if (isEmailReport) {
      window.localStorage.setItem(`checklist_report_${checklistId}`, pdfRes.data.file)
    } else {
      window.open(`${pdfRes.data.download_url}`, '_blank')
    }

    return true
  },
  generatingContentForPDF (formName, listOfFields, fields, logoBase64, checklilstName = '', projectdata = '', allTransData, reportHeader = '') {
    const result = generatePDFContent(formName, listOfFields, fields, componentStatusList, logoBase64, checklilstName, projectdata, allTransData, false, reportHeader)
    return result
  },
  generatingContentForPDFDataGrid (formName, listOfFields, fields, logoBase64, checklilstName = '', projectdata = '', allTransData, dataGridShow, reportHeader = '') {
    const result = generatePDFContent(formName, listOfFields, fields, componentStatusList, logoBase64, checklilstName, projectdata, allTransData, dataGridShow, reportHeader)
    return result
  },
  checkAndGetSumRowData (labels) {
    const obj = { showSumRow: false, sumColIndexes: [] }
    labels.forEach((label, index) => {
      const { field } = label
      if (field && field.typedata && field.typedata.isshowsum) {
        obj.showSumRow = true
        obj.sumColIndexes.push(index)
      }
    })
    return obj
  },
  mimeTypeOfAttachment ({ file_original_name: fileOriginalName, file_guid: fileGuid }) {
    let image = ''
    const ext = fileOriginalName.split('.').pop()
    const extension = ext ? ext.toString().toLowerCase() : ''

    switch (extension) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'gif':
        image = {
          icon: 'mdi-file-image',
          color: null,
          url: `${documentUrl}Documents/${fileGuid}?t=${Date.now()}`
        }
        break

      default:
        image = {
          icon: 'mdi-file-document',
          color: null,
          url: null
        }
        break
    }
    return image
  }
}
